module.exports = __webpack_public_path__ + "img/banner.946c16e8.png";